import { parseFromString } from 'dom-parser';

export class StringHelper {
  static stripTags(html: string): string {
    html = html.replaceAll('&nbsp;', '');

    const wrappedHtml = `<div id="string-helper-wrapper">${html}</div>`;
    const dom = parseFromString(wrappedHtml);
    const rootNode = dom.getElementById('string-helper-wrapper');

    const filteredChildren = rootNode.childNodes.filter(node => node.textContent.length > 1);

    return filteredChildren[0].textContent;
  }
}
